// -----------------------------------------------------------------------------
// This file contains form validation and form input creation helpers
// -----------------------------------------------------------------------------
import React from 'react';
import Cleave from 'cleave.js/react';
import _filter from 'lodash/filter';

export const validate = values => {

  const errors = {};
  if (!values.firstName) {
    errors.firstName = 'Your first name is required';
  }else if (values.firstName.length < 2) {
    errors.firstName = 'Your first name is too short';
  }

  if (!values.surname) {
    errors.surname = 'Your surname is required';
  }else if (values.surname.length < 2) {
    errors.surname = 'Your surname is too short';
  }


  if (!values.email) {
    errors.email = 'Your email address is required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Invalid email address';
  }

  if (!values.phoneLockout) {
    errors.phoneLockout = 'A phone number is required';
  }

  // if(!/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(values.phone)){
  //   errors.phone = "Phone number invalid";
  // }
  // else if (values.phone.length < 10) {
  //   errors.phone = 'Must be a valid 10 digit phone number';
  // }

  if (!values.information) {
    errors.information = 'Please enter some information on your request.';
  }

  if(!values.address) {
    errors.address = 'Your address is required';
  }

  if(!values.address2) {
    errors.address2 = 'Your address is required';
  }


  if(!values.city){
    errors.city = 'Your city is required';
  }

  if(!values.postcode){
    errors.postcode = 'Your postcode is required';
  }

  if(!values.clientref){
    errors.clientref = "Client ref number is required";
  }else if(!/^[0-9]*$/.test(values.cardnumber)){
    errors.clientref = "Client ref number invalid";
  }

  if(!values.expiry){
    errors.expiry = "Your expiry date is required";
  }else if(!/^(0[1-9]|1[0-2])\/[0-9]{2}$/.test(values.expiry)){
    errors.expiry = "Expiry date invalid";
  }

  if(!values.cvv){
    errors.cvv = "CVV number is required";
  }else if(!/^[0-9]{3,4}$/.test(values.cvv)){
    errors.cvv = "CVV number invalid";
  }

  if(!values.dob){
    errors.dob = "Date of birth is required";
  }else if(!/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/.test(values.dob)){
    errors.dob = "Date of birth invalid";
  }else if( (new Date().getFullYear() - (values.dob.substring(values.dob.lastIndexOf("/") + 1, values.dob.length)) ) < 18){
    errors.dob = "Passengers must be aged 18 years or over";
  }

  if(!values.nationality){
    errors.nationality = 'Your nationality is required';
  }

  if(!values.state){
    errors.state = 'Your state is required';
  }

  if (!values.emergency) {
    errors.emergency = 'A phone number is required';
  }

  if(!values.emergencyPrefix){
    errors.emergencyPrefix = 'Your phone number is required';
  }

  return errors
}

//STANDARD INPUT FIELDS
export const renderField = ({ input, label, type, placeholder, classType, meta: { touched, error, warning, invalid } }) => (
  <div className={classType}>
    <label>{label}</label>
    <div>
      <input {...input} placeholder={placeholder} type={type} className={(touched && invalid) ? 'error': '' }/>
      {touched && ((error && <span className="form-error">{error}</span>) || (warning && <span>{warning}</span>))}
    </div>
  </div>
)

export const renderTextField = ({ input, label, meta: { touched, error, warning } }) => (
  <div>
    <label>{label}</label>
    <div>
      <textarea {...input} placeholder={label}/>
      {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
    </div>
  </div>
 )

 export const renderSelectField = ({ input, label, classType, selectedValue, children, meta: { touched, error, warning, invalid} }) => (
   <div className={classType}>
     <label>{label}</label>
     <div>
       <select {...input} className={(touched && invalid) ? 'error': '' }>
         {children}
       </select>
       {touched && ((error && <span className="form-error">{error}</span>) || (warning && <span>{warning}</span>))}
     </div>
   </div>
 )

//MATERIAL DESIGN INPUT FIELDS
export const renderMaterialField = ({ input, label, type, fieldId, meta: { touched, error, warning, invalid } }) => (
  <div className="material-input">
  <label htmlFor={fieldId} className={ `${(touched && invalid) ? 'error': '' }`}>
    <span>{label}</span>
    <input
      {...input}
      id={fieldId}
      className="input-control"
      type={type}
      onBlur={(e) => { if(e.target.value === "") e.target.parentElement.parentElement.classList.remove('hovered'); } }
      onFocus={(e) => { e.target.parentElement.parentElement.classList.add('hovered'); } }
    />

  </label>
  {touched && ((error && <span className="form-error">{error}</span>) || (warning && <span>{warning}</span>))}
  </div>
)

export const renderCleaveMaterialField = ({ input, label, type, fieldId, meta: { touched, error, warning, invalid } }) => (
  <div className="material-input">
  <label htmlFor={fieldId} className={ `${(touched && invalid) ? 'error': '' }`}>
    <span>{label}</span>
    <Cleave
      {...input}
      id={fieldId}
      className="input-control"
      options={{date: true, datePattern: ['d', 'm', 'Y'], delimiters: ['/']}}
      type={type}
      onBlur={(e) => { if(e.target.value === "") e.target.parentElement.parentElement.classList.remove('hovered'); } }
      onFocus={(e) => { e.target.parentElement.parentElement.classList.add('hovered'); } }
    />

  </label>
  {touched && ((error && <span className="form-error">{error}</span>) || (warning && <span>{warning}</span>))}
  </div>
)

export const renderDisabledField = (htmlLabel, labelText, inputValue) => {
  return (
    <div className="material-input hovered">
      <label htmlFor={ htmlLabel }>
        <span>{ labelText }</span>
        <input id={ htmlLabel } className="input-control" type="text" value={inputValue} disabled  />
      </label>
    </div>
  )
}


//DROP DOWN HELPERS
export const popularCountriesArr = (searchArr, populateCountries) => {
  let _arr = [];
  if(searchArr && searchArr.length > 0){
    for(let i = 0; i < searchArr.length; i++){
      for(let ii = 0; ii < populateCountries.length; ii++){
        if(searchArr[i].name === populateCountries[ii]){
          _arr.push(searchArr[i]);
        }
      }
    }
    return _arr;
  }else{
    return _arr;
  }
}


export const checkValidCountries = (arr, country) =>{
  const _arr =  _filter(arr, {'dialing_code': country});
  return (_arr.length === 0) ? true : false;
}

export const checkValidState = (arr, state) => {
  const _arr = _filter(arr, {'name': state});
  return (_arr.length === 0) ? true : false;
}

//TOGGLING ACTIVE AND ERROR STATES FOR CUSTOM DROP DOWNS
export const customFormErrors = (obj) => {

  if(window.innerWidth > 640){
    if(obj.dropdown !== null){
      if(obj.addRemove === 'add' && obj.formValue === ""){
        obj.dropdown.classList.add('error');
        obj.errorText.classList.add('active');
      }else{
        obj.dropdown.classList.remove('error');
        obj.errorText.classList.remove('active');
      }
    }
  }
}


//UTILS
export const serializeObj = (obj) => {
    var result = [];
    for (var property in obj) result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
    return result.join("&");
}



// WEBPACK FOOTER //
// ./src/helpers/formHelper.js